import Vue from "vue";
const bus = new Vue();

export default bus;



// WEBPACK FOOTER //
// ./resources/assets/js/bus.js